import axios from "axios";
import { useState, useEffect, useMemo } from "react";

const apiUrlPlatos = `${process.env.REACT_APP_API_URL}/platos`;
const apiUrlMenuSemanals = `${process.env.REACT_APP_API_URL}/menu-semanals`;
const apiUrlAddresses = `${process.env.REACT_APP_API_URL}/addres`;
// Las rutas /tipos-plato y /bebidas están al mismo nivel que /platos en el router
const apiUrlBebidas = `${process.env.REACT_APP_API_URL}/bebidas`;
const apiUrlTipos = `${process.env.REACT_APP_API_URL}/tipos-plato`;

const getTipoPlatoNombre = (plato) => plato?.tipoplato?.nombre || plato?.plato?.tipoplato?.nombre || plato?.tipo || 'Sin clasificar';

function AbmPlatos() {
  const [platos, setPlatos] = useState([]);
  const [sedes, setSedes] = useState([]);
  const [searchTerms, setSearchTerms] = useState({});
  const [platosAlmuerzo, setPlatosAlmuerzo] = useState([]);
  const [platosCena, setPlatosCena] = useState([]);
  const [fechaSeleccionada, setFechaSeleccionada] = useState('');
  const [sedeSeleccionada, setSedeSeleccionada] = useState('');
  const [tipoComida, setTipoComida] = useState('almuerzo');
  const [bebidas, setBebidas] = useState([]);
  const [bebidasSeleccionadas, setBebidasSeleccionadas] = useState([]);
  const [aplicacionBebidas, setAplicacionBebidas] = useState('ambas'); // 'ambas', 'almuerzo', 'cena'
  const [mostrarModalConfirmacion, setMostrarModalConfirmacion] = useState(false);
  const [tiposActivos, setTiposActivos] = useState([]);
  const [tipoMenuSeleccionado, setTipoMenuSeleccionado] = useState('');
  const [busquedaPlato, setBusquedaPlato] = useState('');
  const [diasCargados, setDiasCargados] = useState([]); // Para rastrear qué días ya tienen menú cargado

  // Filtrar tipos únicos: solo mostrar los que están en tiposActivos
  const tiposUnicosDePlatos = [...new Set(platos.map(getTipoPlatoNombre))]
    .filter(tipo => tipo && (tiposActivos.length === 0 || tiposActivos.includes(tipo)));

  // Agregar "Bebidas" si hay bebidas activas
  const tiposUnicos = useMemo(() => {
    return bebidas.length > 0
      ? [...tiposUnicosDePlatos, 'Bebidas']
      : tiposUnicosDePlatos;
  }, [tiposUnicosDePlatos, bebidas.length]);

  useEffect(() => {
    getPlatos();
    getSedes();
    getBebidas();
    getTiposActivos();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // Cargar los días ya cargados cuando se selecciona una sede
  useEffect(() => {
    if (sedeSeleccionada) {
      cargarDiasCargados();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [sedeSeleccionada]);



  useEffect(() => {
    // Auto-seleccionar el primer tipo si hay tipos disponibles y no hay uno seleccionado
    if (tiposUnicos.length > 0 && !tipoMenuSeleccionado) {
      setTipoMenuSeleccionado(tiposUnicos[0]);
    }
  }, [tiposUnicos, tipoMenuSeleccionado]);

  const getPlatos = async () => {
    try {
      // Los platos ahora son globales, no filtrar por sede
      const res = await axios.get(apiUrlPlatos);
      setPlatos(res.data);
    } catch (error) {
      console.error('Error al obtener los platos:', error);
    }
  };

  const getSedes = async () => {
    try {
      const res = await axios.get(apiUrlAddresses);
      setSedes(res.data);
    } catch (error) {
      console.error('Error al obtener las sedes:', error);
    }
  };

  const getBebidas = async () => {
    try {
      const res = await axios.get(`${apiUrlBebidas}?activo=1`);
      setBebidas(res.data);
    } catch (error) {
      console.error('Error al obtener las bebidas:', error);
    }
  };



  const getTiposActivos = async () => {
    try {
      const res = await axios.get(`${apiUrlTipos}/activos`);
      const nombresActivos = res.data.map(t => t.nombre);
      console.log('Tipos activos obtenidos:', nombresActivos);
      setTiposActivos(nombresActivos);
    } catch (error) {
      console.error('Error al obtener tipos activos:', error);
      // Si falla, permitir todos los tipos (fallback)
      setTiposActivos([]);
    }
  };

  const cargarDiasCargados = async () => {
    try {
      // Obtener todos los menús semanales de la sede seleccionada
      const response = await axios.get(apiUrlMenuSemanals);
      console.log('🔍 Todos los menús:', response.data);
      console.log('🔍 ID Sede buscada:', sedeSeleccionada, 'tipo:', typeof sedeSeleccionada);

      // Filtrar por sede - comparar como números
      const sedeId = parseInt(sedeSeleccionada);
      const menusDeSede = response.data.filter(menu => {
        console.log('Comparando:', menu.id_sede, '===', sedeId, '?', menu.id_sede === sedeId);
        return menu.id_sede === sedeId;
      });

      console.log('✅ Menús de esta sede:', menusDeSede);
      const fechasUnicas = [...new Set(menusDeSede.map(menu => menu.fecha))];
      console.log('📅 Fechas únicas:', fechasUnicas);

      // Convertir fechas a objetos con información del día
      const diasConInfo = fechasUnicas.map(fecha => {
        // Parsear la fecha como YYYY-MM-DD sin conversión de zona horaria
        const [year, month, day] = fecha.split('-').map(Number);
        const fechaObj = new Date(year, month - 1, day); // Constructor de Date con año, mes (0-11), día

        // Obtener día de la semana en español
        const dias = ['domingo', 'lunes', 'martes', 'miércoles', 'jueves', 'viernes', 'sábado'];
        const meses = ['ene', 'feb', 'mar', 'abr', 'may', 'jun', 'jul', 'ago', 'sep', 'oct', 'nov', 'dic'];

        return {
          fecha: fecha,
          dia: dias[fechaObj.getDay()].charAt(0).toUpperCase() + dias[fechaObj.getDay()].slice(1),
          numerodia: fechaObj.getDate(),
          mes: meses[fechaObj.getMonth()],
          numeroDia: fechaObj.getDay() // Para ordenar (1=lunes, 2=martes, etc)
        };
      });

      // Ordenar por día de semana (lunes primero)
      // Convertir domingo (0) a 7 para que quede al final
      const diasOrdenados = diasConInfo.sort((a, b) => {
        const diaA = a.numeroDia === 0 ? 7 : a.numeroDia;
        const diaB = b.numeroDia === 0 ? 7 : b.numeroDia;
        return diaA - diaB;
      });

      console.log('🎉 Días con info (ordenados):', diasOrdenados);
      setDiasCargados(diasOrdenados);
    } catch (error) {
      console.error('❌ Error al obtener días cargados:', error);
      setDiasCargados([]);
    }
  };

  const handleSeleccionarPlato = (platoSeleccionado) => {
    // Si se selecciona una bebida desde la vista de "Bebidas", agregarla al array
    if (platoSeleccionado && platoSeleccionado.id_bebida) {
      // Verificar si ya está seleccionada para evitar duplicados
      const yaSeleccionada = bebidasSeleccionadas.some(b => b.id_bebida === platoSeleccionado.id_bebida);
      if (!yaSeleccionada) {
        setBebidasSeleccionadas([...bebidasSeleccionadas, {
          id_bebida: platoSeleccionado.id_bebida,
          tipo: platoSeleccionado.tipo,
          marca: platoSeleccionado.marca,
          sabor: platoSeleccionado.sabor,
        }]);
      }
      return;
    }

    if (tipoComida === 'almuerzo') {
      setPlatosAlmuerzo([...platosAlmuerzo, { ...platoSeleccionado, comida: 'almuerzo' }]);
    } else {
      setPlatosCena([...platosCena, { ...platoSeleccionado, comida: 'cena' }]);
    }
  };

  // const handleVaciarPlatos = () => {
  //   if (tipoComida === 'almuerzo') {
  //     setPlatosAlmuerzo([]);
  //   } else {
  //     setPlatosCena([]);
  //   }
  // };

  const handleVaciarTodo = () => {
    setPlatosAlmuerzo([]);
    setPlatosCena([]);
    setBebidasSeleccionadas([]);
  };

  const handleGuardarPlatos = async () => {
    const todosLosPlatos = [...platosAlmuerzo, ...platosCena];

    if (!sedeSeleccionada) {
      alert('Por favor, selecciona una sede antes de guardar.');
      return;
    }

    // Si hay bebidas disponibles pero no se seleccionó ninguna, mostrar confirmación
    if (bebidas.length > 0 && bebidasSeleccionadas.length === 0) {
      setMostrarModalConfirmacion(true);
      return;
    }

    if (todosLosPlatos.length > 0 && fechaSeleccionada) {
      const formatoFechaCorrecto = /^\d{4}-\d{2}-\d{2}$/.test(fechaSeleccionada);
      if (formatoFechaCorrecto) {
        try {
          // Crear registros de menú para platos
          const platosParaGuardar = todosLosPlatos.map(plato => ({
            id_plato: plato.id_plato,
            nombre: plato.nombre,
            descripcion: plato.descripcion,
            fecha: fechaSeleccionada,
            id_sede: parseInt(sedeSeleccionada),
            comida: plato.comida,
            bebida_id: null
          }));

          // Crear registros de menú para bebidas según la opción seleccionada
          const bebidasParaGuardar = [];
          bebidasSeleccionadas.forEach(bebida => {
            if (aplicacionBebidas === 'ambas') {
              // Crear una para almuerzo y otra para cena
              bebidasParaGuardar.push({
                id_plato: null,
                nombre: `${bebida.marca} - ${bebida.sabor}`,
                descripcion: bebida.tipo,
                tipo: 'Bebidas',
                fecha: fechaSeleccionada,
                id_sede: parseInt(sedeSeleccionada),
                comida: 'almuerzo',
                bebida_id: bebida.id_bebida
              });
              bebidasParaGuardar.push({
                id_plato: null,
                nombre: `${bebida.marca} - ${bebida.sabor}`,
                descripcion: bebida.tipo,
                tipo: 'Bebidas',
                fecha: fechaSeleccionada,
                id_sede: parseInt(sedeSeleccionada),
                comida: 'cena',
                bebida_id: bebida.id_bebida
              });
            } else {
              // Solo para la comida seleccionada
              bebidasParaGuardar.push({
                id_plato: null,
                nombre: `${bebida.marca} - ${bebida.sabor}`,
                descripcion: bebida.tipo,
                tipo: 'Bebidas',
                fecha: fechaSeleccionada,
                id_sede: parseInt(sedeSeleccionada),
                comida: aplicacionBebidas, // 'almuerzo' o 'cena'
                bebida_id: bebida.id_bebida
              });
            }
          });

          const nuevosPlatos = [...platosParaGuardar, ...bebidasParaGuardar];

          await axios.post(apiUrlMenuSemanals, { nuevosPlatos });
          setPlatosAlmuerzo([]);
          setPlatosCena([]);
          setFechaSeleccionada('');
          setBebidasSeleccionadas([]);
          alert('✅ Menú guardado correctamente para la sede seleccionada');
          getPlatos();
        } catch (error) {
          console.error('Error al guardar los platos:', error);
          alert('❌ Error al guardar el menú');
        }
      } else {
        alert('La fecha seleccionada no tiene el formato correcto (YYYY-MM-DD).');
      }
    } else {
      alert('Selecciona platos y una fecha antes de guardar.');
    }
  };

  const handleConfirmarSinBebida = async () => {
    setMostrarModalConfirmacion(false);
    const todosLosPlatos = [...platosAlmuerzo, ...platosCena];

    if (todosLosPlatos.length > 0 && fechaSeleccionada) {
      const formatoFechaCorrecto = /^\d{4}-\d{2}-\d{2}$/.test(fechaSeleccionada);
      if (formatoFechaCorrecto) {
        try {
          const nuevosPlatos = todosLosPlatos.map(plato => ({
            id_plato: plato.id_plato,
            nombre: plato.nombre,
            descripcion: plato.descripcion,
            fecha: fechaSeleccionada,
            id_sede: parseInt(sedeSeleccionada),
            comida: plato.comida,
            bebida_id: null
          }));
          await axios.post(apiUrlMenuSemanals, { nuevosPlatos });
          setPlatosAlmuerzo([]);
          setPlatosCena([]);
          setFechaSeleccionada('');
          setBebidasSeleccionadas([]);
          alert('✅ Menú guardado correctamente para la sede seleccionada');
          getPlatos();
        } catch (error) {
          console.error('Error al guardar los platos:', error);
          alert('❌ Error al guardar el menú');
        }
      }
    }
  };

  // Selección de bebida ahora se realiza desde el tipo "Bebidas" en la columna central

  // Filtrar platos del tipo seleccionado y por búsqueda
  const platosFiltrados = tipoMenuSeleccionado === 'Bebidas'
    ? bebidas.filter(b => busquedaPlato === '' ||
      b.marca.toLowerCase().includes(busquedaPlato.toLowerCase()) ||
      b.sabor.toLowerCase().includes(busquedaPlato.toLowerCase()))
    : platos
      .filter(p => getTipoPlatoNombre(p) === tipoMenuSeleccionado)
      .filter(p => busquedaPlato === '' || p.nombre.toLowerCase().includes(busquedaPlato.toLowerCase()));

  return (
    <div className="min-h-screen bg-gradient-to-br from-green-50 via-emerald-50 to-teal-50 py-8 px-4">
      <div className="max-w-7xl mx-auto">
        {/* Header */}
        <div className="bg-white rounded-2xl shadow-xl p-6 mb-6 border-b-4 border-green-500">
          <div className="flex items-center gap-4 mb-6">
            <div className="bg-gradient-to-br from-green-500 to-emerald-600 p-4 rounded-xl shadow-lg">
              <svg className="w-8 h-8 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2m-6 9l2 2 4-4" />
              </svg>
            </div>
            <div>
              <h1 className="text-3xl font-bold text-gray-800">Carga de Menú Semanal</h1>
              <p className="text-gray-600 mt-1">Configura el menú de la semana para cada sede</p>
            </div>
          </div>

          {/* Selector de Sede */}
          <div className="bg-gradient-to-r from-green-50 to-emerald-50 rounded-xl p-4 border-2 border-green-200">
            <label className="block text-sm font-bold text-gray-700 mb-2">📍 Selecciona la Sede</label>
            <select
              className="w-full max-w-md bg-white text-gray-800 border-2 border-gray-300 p-3 rounded-lg font-medium shadow-sm focus:border-green-500 focus:ring-2 focus:ring-green-200 transition"
              onChange={(e) => setSedeSeleccionada(e.target.value)}
              value={sedeSeleccionada || ""}
            >
              <option value="">-- Selecciona una sede --</option>
              {sedes.map((sede) => (
                <option key={sede.id_direccion} value={sede.id_direccion}>
                  {sede.nombre_sede || `${sede.direccion} - ${sede.localidad}`}
                </option>
              ))}
            </select>
            {sedeSeleccionada && (
              <p className="mt-2 text-sm text-green-700 font-medium">
                ✅ Los platos se asignarán a esta sede
              </p>
            )}
          </div>

          {/* Selector de Fecha con indicador visual */}
          <div className="bg-gradient-to-r from-blue-50 to-cyan-50 rounded-xl p-4 border-2 border-blue-200 mt-4">
            <label className="block text-sm font-bold text-gray-700 mb-3">📅 Selecciona la Fecha del Menú</label>
            <div className="flex flex-col sm:flex-row gap-4 items-stretch sm:items-center">
              <input
                type="date"
                value={fechaSeleccionada}
                onChange={(e) => setFechaSeleccionada(e.target.value)}
                className="flex-1 bg-white text-gray-900 border-2 border-gray-300 px-4 py-3 rounded-lg font-medium shadow-sm focus:border-blue-500 focus:ring-2 focus:ring-blue-200 transition"
              />
              {fechaSeleccionada && (
                <div className="bg-gradient-to-r from-blue-500 to-cyan-500 text-white px-4 py-3 rounded-lg font-bold shadow-lg text-center sm:text-left whitespace-nowrap">
                  {new Date(fechaSeleccionada).toLocaleDateString('es-ES', {
                    weekday: 'long',
                    year: 'numeric',
                    month: 'long',
                    day: 'numeric'
                  }).charAt(0).toUpperCase() + new Date(fechaSeleccionada).toLocaleDateString('es-ES', {
                    weekday: 'long',
                    year: 'numeric',
                    month: 'long',
                    day: 'numeric'
                  }).slice(1)}
                </div>
              )}
            </div>
          </div>

          {/* Indicador de Días Cargados */}
          {!sedeSeleccionada ? (
            <div className="bg-gradient-to-r from-yellow-50 to-amber-50 rounded-xl p-4 border-2 border-yellow-200 mt-4">
              <h3 className="text-sm font-bold text-amber-700 mb-2">⚠️ Selecciona una Sede</h3>
              <p className="text-sm text-amber-600">Para ver los menús ya cargados, primero debes seleccionar una sucursal en el apartado anterior.</p>
            </div>
          ) : diasCargados.length > 0 ? (
            <div className="bg-gradient-to-r from-purple-50 to-pink-50 rounded-xl p-4 border-2 border-purple-200 mt-4">
              <h3 className="text-sm font-bold text-gray-700 mb-3">📋 Menús Cargados para esta Sede:</h3>
              <div className="flex flex-wrap gap-2">
                {diasCargados.map((dia) => (
                  <div
                    key={dia.fecha}
                    className="bg-gradient-to-r from-purple-500 to-pink-500 text-white px-3 py-2 rounded-lg font-bold text-sm shadow-md flex flex-col items-center min-w-24"
                  >
                    <span className="text-xs opacity-90 capitalize">{dia.dia}</span>
                    <span className="text-lg">{dia.numerodia}</span>
                    <span className="text-xs opacity-90">{dia.mes}</span>
                  </div>
                ))}
              </div>
            </div>
          ) : (
            <div className="bg-gradient-to-r from-green-50 to-emerald-50 rounded-xl p-4 border-2 border-green-200 mt-4">
              <h3 className="text-sm font-bold text-green-700 mb-2">✅ Sin Menús Cargados</h3>
              <p className="text-sm text-green-600">Esta sede aún no tiene menús cargados. ¡Comienza cargando uno!</p>
            </div>
          )}
        </div>

        {/* Layout de 3 columnas */}
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-4">
          {/* Columna izquierda: Lista de tipos de menú */}
          <div className="lg:col-span-2 bg-white rounded-xl shadow-lg p-4 max-h-[600px] overflow-y-auto border border-gray-200">
            <h3 className="text-base font-bold mb-3 text-gray-800 flex items-center gap-2">
              <span>📋</span> Tipos de Menú
            </h3>
            <div className="space-y-2">
              {tiposUnicos.map((tipo) => (
                <button
                  key={tipo}
                  onClick={() => {
                    setTipoMenuSeleccionado(tipo);
                    setBusquedaPlato('');
                  }}
                  className={`w-full text-left px-3 py-2.5 rounded-lg transition-all font-medium text-sm ${tipoMenuSeleccionado === tipo
                    ? 'bg-gradient-to-r from-green-500 to-emerald-600 text-white font-bold shadow-md transform scale-105'
                    : 'bg-gray-100 hover:bg-gray-200 text-gray-700 hover:shadow-md'
                    }`}
                >
                  {tipo}
                </button>
              ))}
            </div>
          </div>

          {/* Columna central: Platos del tipo seleccionado */}
          <div className="lg:col-span-6 bg-white rounded-xl shadow-lg p-4 border border-gray-200">
            <div className="mb-4">
              <h3 className="text-lg font-bold mb-3 text-gray-800">
                {tipoMenuSeleccionado ? `🍽️ ${tipoMenuSeleccionado}` : '🍽️ Selecciona un tipo de menú'}
              </h3>
              <input
                type="text"
                placeholder="🔍 Buscar plato..."
                value={busquedaPlato}
                onChange={(e) => setBusquedaPlato(e.target.value)}
                className="w-full p-3 rounded-lg bg-gray-50 text-gray-800 border-2 border-gray-300 focus:border-green-500 focus:ring-2 focus:ring-green-200 transition"
              />
            </div>

            <div className="max-h-[500px] overflow-y-auto space-y-2">
              {platosFiltrados.length === 0 ? (
                <p className="text-center text-gray-500 py-8">
                  {tipoMenuSeleccionado ? 'No hay items disponibles' : 'Selecciona un tipo de menú'}
                </p>
              ) : (
                tipoMenuSeleccionado === 'Bebidas' ? (
                  // Renderizar bebidas
                  platosFiltrados.map((bebida) => (
                    <div
                      key={bebida.id_bebida}
                      className="bg-gradient-to-r from-blue-50 to-cyan-50 border-2 border-blue-200 rounded-lg p-3 hover:shadow-md transition-all flex justify-between items-center gap-3"
                    >
                      <div className="flex-1 min-w-0">
                        <h4 className="font-semibold text-gray-800 text-sm sm:text-base truncate">
                          {bebida.tipo === 'gaseosa' ? '🥤' : '💧'} {bebida.marca} - {bebida.sabor}
                        </h4>
                        <p className="text-xs sm:text-sm text-gray-600 truncate">
                          {bebida.tipo.charAt(0).toUpperCase() + bebida.tipo.slice(1)}
                          {bebida.precio ? ` - $${bebida.precio}` : ''}
                        </p>
                      </div>
                      <button
                        onClick={() => handleSeleccionarPlato({
                          id_bebida: bebida.id_bebida,
                          nombre: `${bebida.marca} - ${bebida.sabor}`,
                          descripcion: bebida.tipo,
                          tipo: 'Bebidas',
                          marca: bebida.marca,
                          sabor: bebida.sabor,
                        })}
                        className="bg-gradient-to-r from-green-500 to-emerald-600 hover:from-green-600 hover:to-emerald-700 text-white px-4 py-2 rounded-lg font-bold shadow-md hover:shadow-lg transition-all flex-shrink-0 text-sm sm:text-base"
                      >
                        +
                      </button>
                    </div>
                  ))
                ) : (
                  // Renderizar platos normales
                  platosFiltrados.map((plato) => (
                    <div
                      key={plato.id_plato}
                      className="bg-gradient-to-r from-gray-50 to-gray-100 border-2 border-gray-200 rounded-lg p-3 hover:shadow-md transition-all flex justify-between items-center gap-3"
                    >
                      <div className="flex-1 min-w-0">
                        <h4 className="font-semibold text-gray-800 text-sm sm:text-base truncate">
                          {plato.nombre}
                        </h4>
                        <p className="text-xs sm:text-sm text-gray-600 truncate">
                          {plato.descripcion}
                        </p>
                      </div>
                      <button
                        onClick={() => handleSeleccionarPlato(plato)}
                        className="bg-gradient-to-r from-green-500 to-emerald-600 hover:from-green-600 hover:to-emerald-700 text-white px-4 py-2 rounded-lg font-bold shadow-md hover:shadow-lg transition-all flex-shrink-0 text-sm sm:text-base"
                      >
                        +
                      </button>
                    </div>
                  ))
                )
              )}
            </div>
          </div>

          {/* Columna derecha: Platos seleccionados y oferta de bebidas */}
          <div className="lg:col-span-4 bg-white rounded-xl shadow-xl border-2 border-green-200 p-4 lg:p-6 self-start sticky top-4">
            <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-2 sm:gap-0 mb-4">
              <h2 className="text-base sm:text-lg lg:text-xl font-bold text-gray-800">Platos Seleccionados</h2>
              {tipoMenuSeleccionado !== 'Bebidas' && (
                <select
                  value={tipoComida}
                  onChange={(e) => setTipoComida(e.target.value)}
                  className="w-full sm:w-auto bg-gradient-to-r from-green-500 to-emerald-600 text-white border-2 border-green-600 px-3 py-1.5 sm:py-2 rounded-lg font-bold shadow-md hover:from-green-600 hover:to-emerald-700 transition text-sm sm:text-base"
                >
                  <option value="almuerzo" className="bg-white text-gray-800">Almuerzo</option>
                  <option value="cena" className="bg-white text-gray-800">Cena</option>
                </select>
              )}
            </div>

            {/* Grid de dos columnas: Platos a la izquierda, Bebidas a la derecha */}
            <div className="grid grid-cols-1 md:grid-cols-2 gap-3 md:gap-4 mb-4">
              {/* Columna izquierda: Platos */}
              <div>
                {/* Sección Almuerzo */}
                <div className="mb-3 bg-gradient-to-br from-orange-50 to-amber-50 p-3 sm:p-4 rounded-lg border-2 border-orange-200">
                  <h3 className="text-sm font-bold text-orange-700 mb-2 flex items-center gap-2">
                    <span>☀️</span> Almuerzo
                  </h3>
                  {platosAlmuerzo.length === 0 ? (
                    <p className="text-xs sm:text-sm text-gray-500 italic">Sin platos</p>
                  ) : (
                    <ul className="list-disc list-inside text-gray-800 space-y-1">
                      {platosAlmuerzo.map((plato, index) => (
                        <li key={index} className="text-xs sm:text-sm break-words">{plato.nombre} - <span className="text-orange-600 font-semibold">{getTipoPlatoNombre(plato)}</span></li>
                      ))}
                    </ul>
                  )}
                </div>

                {/* Sección Cena */}
                <div className="bg-gradient-to-br from-purple-50 to-indigo-50 p-3 sm:p-4 rounded-lg border-2 border-purple-200">
                  <h3 className="text-sm font-bold text-purple-700 mb-2 flex items-center gap-2">
                    <span>🌙</span> Cena
                  </h3>
                  {platosCena.length === 0 ? (
                    <p className="text-xs sm:text-sm text-gray-500 italic">Sin platos</p>
                  ) : (
                    <ul className="list-disc list-inside text-gray-800 space-y-1">
                      {platosCena.map((plato, index) => (
                        <li key={index} className="text-xs sm:text-sm break-words">{plato.nombre} - <span className="text-purple-600 font-semibold">{getTipoPlatoNombre(plato)}</span></li>
                      ))}
                    </ul>
                  )}
                </div>
              </div>

              {/* Columna derecha: Bebidas */}
              <div>
                <div className="bg-gradient-to-br from-blue-50 to-cyan-50 p-3 sm:p-4 rounded-lg border-2 border-blue-200 h-full">
                  <h3 className="text-sm font-bold text-blue-700 mb-2 flex items-center gap-2">
                    <span>🥤</span> Bebidas
                  </h3>
                  {bebidasSeleccionadas.length === 0 ? (
                    <p className="text-xs sm:text-sm text-gray-500 italic">Sin bebidas</p>
                  ) : (
                    <ul className="space-y-2">
                      {bebidasSeleccionadas.map((bebida, index) => (
                        <div key={index} className="flex items-center justify-between gap-2 bg-white border border-blue-200 rounded-lg px-2 py-1">
                          <div className="text-xs text-blue-700 font-semibold truncate flex-1">
                            {bebida.tipo === 'gaseosa' ? '🥤' : '💧'} {bebida.marca} - {bebida.sabor}
                          </div>
                          <button
                            onClick={() => setBebidasSeleccionadas(bebidasSeleccionadas.filter((_, i) => i !== index))}
                            className="text-xs bg-red-500 hover:bg-red-600 text-white px-1.5 py-0.5 rounded font-medium flex-shrink-0"
                          >
                            ✕
                          </button>
                        </div>
                      ))}
                    </ul>
                  )}
                </div>
              </div>
            </div>

            {/* Sección de configuración de bebidas y botones */}
            <div className="flex flex-col gap-3 sm:gap-4">
              {bebidasSeleccionadas.length > 0 && (
                <div className="bg-gradient-to-br from-blue-50 to-cyan-50 border-2 border-blue-200 rounded-lg p-3 space-y-2">
                  <div className="text-xs text-gray-600 mb-2 font-medium">Aplicar bebidas a:</div>
                  <div className="flex flex-col gap-2">
                    <label className="flex items-center gap-2 cursor-pointer text-xs sm:text-sm">
                      <input
                        type="radio"
                        name="aplicacionBebidas"
                        value="ambas"
                        checked={aplicacionBebidas === 'ambas'}
                        onChange={(e) => setAplicacionBebidas(e.target.value)}
                        className="w-4 h-4 accent-green-600"
                      />
                      <span className="text-gray-700 font-medium">🍽️ Almuerzo y Cena</span>
                    </label>
                    <label className="flex items-center gap-2 cursor-pointer text-xs sm:text-sm">
                      <input
                        type="radio"
                        name="aplicacionBebidas"
                        value="almuerzo"
                        checked={aplicacionBebidas === 'almuerzo'}
                        onChange={(e) => setAplicacionBebidas(e.target.value)}
                        className="w-4 h-4 accent-green-600"
                      />
                      <span className="text-gray-700 font-medium">☀️ Solo Almuerzo</span>
                    </label>
                    <label className="flex items-center gap-2 cursor-pointer text-xs sm:text-sm">
                      <input
                        type="radio"
                        name="aplicacionBebidas"
                        value="cena"
                        checked={aplicacionBebidas === 'cena'}
                        onChange={(e) => setAplicacionBebidas(e.target.value)}
                        className="w-4 h-4 accent-green-600"
                      />
                      <span className="text-gray-700 font-medium">🌙 Solo Cena</span>
                    </label>
                  </div>
                </div>
              )}

              <div className="flex flex-col gap-2">
                <button onClick={handleGuardarPlatos} className="bg-gradient-to-r from-green-500 to-emerald-600 hover:from-green-600 hover:to-emerald-700 text-white font-bold px-4 py-2.5 sm:py-3 rounded-lg w-full shadow-lg transition transform hover:scale-105 text-sm sm:text-base">
                  💾 Guardar Todo
                </button>
                <div className="grid grid-cols-2 gap-2">
                  <button
                    onClick={() => setPlatosAlmuerzo([])}
                    className="bg-gradient-to-r from-orange-400 to-amber-500 hover:from-orange-500 hover:to-amber-600 text-white font-semibold px-2 sm:px-3 py-2 rounded-lg w-full shadow-md transition text-xs sm:text-sm"
                  >
                    🗑 Almuerzo
                  </button>
                  <button
                    onClick={() => setPlatosCena([])}
                    className="bg-gradient-to-r from-orange-400 to-amber-500 hover:from-orange-500 hover:to-amber-600 text-white font-semibold px-2 sm:px-3 py-2 rounded-lg w-full shadow-md transition text-xs sm:text-sm"
                  >
                    🗑 Cena
                  </button>
                </div>
                <button onClick={handleVaciarTodo} className="bg-gradient-to-r from-red-500 to-red-600 hover:from-red-600 hover:to-red-700 text-white font-bold px-4 py-2 rounded-lg w-full shadow-lg transition text-sm sm:text-base">
                  🗑 Vaciar Todo
                </button>
              </div>
            </div>
          </div>
        </div>

        {/* Modal de Confirmación */}
        {mostrarModalConfirmacion && (
          <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 px-4">
            <div className="bg-white rounded-2xl shadow-2xl p-6 max-w-md w-full border-4 border-amber-500">
              <h3 className="text-lg sm:text-xl font-bold mb-4 text-center text-gray-800">⚠️ Confirmación</h3>
              <p className="text-sm sm:text-base mb-6 text-center text-gray-700">
                ¿El menú de la semana seleccionada no tendrá opción de bebidas?
              </p>
              <div className="flex gap-3">
                <button
                  onClick={handleConfirmarSinBebida}
                  className="flex-1 bg-gradient-to-r from-green-500 to-emerald-600 hover:from-green-600 hover:to-emerald-700 text-white font-bold py-3 rounded-lg transition shadow-lg"
                >
                  Sí
                </button>
                <button
                  onClick={() => setMostrarModalConfirmacion(false)}
                  className="flex-1 bg-gradient-to-r from-red-500 to-red-600 hover:from-red-600 hover:to-red-700 text-white font-bold py-3 rounded-lg transition shadow-lg"
                >
                  No
                </button>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

export default AbmPlatos;
